// error-tracking.js
// Captures and reports JavaScript errors to the backend

export function initErrorTracking() {
    // Capture unhandled errors
    window.addEventListener('error', (event) => {
        // Ignore generic "Script error." - these are CORS-blocked errors with no useful info
        if (event.message === 'Script error.' && !event.filename) {
            return;
        }

        // // Ignore browser/platform-specific errors that aren't from our code
        // const ignoredErrors = [
        //     '_AutofillCallbackHandler', // Safari/Instagram in-app browser
        //     'webkit', // WebKit internals
        //     'ResizeObserver loop', // Browser resize observer
        //     'Non-Error promise rejection' // Browser promise handling
        // ];
        
        // if (ignoredErrors.some(ignored => event.message?.includes(ignored))) {
        //     return;
        // }

        const errorData = {
            message: event.message,
            source: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            stack: event.error?.stack || '',
            userAgent: navigator.userAgent,
            url: window.location.href,
            timestamp: new Date().toISOString()
        };

        sendErrorToBackend(errorData);
    });

    // Capture unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
        console.log('unhandledrejection')
        const errorData = {
            message: `Unhandled Promise Rejection: ${event.reason}`,
            source: 'Promise',
            stack: event.reason?.stack || '',
            userAgent: navigator.userAgent,
            url: window.location.href,
            timestamp: new Date().toISOString()
        };

        sendErrorToBackend(errorData);
    });
}

function sendErrorToBackend(errorData) {
    // Use sendBeacon for reliability (works even when page is unloading)
    if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(errorData)], { type: 'application/json' });
        navigator.sendBeacon('/api/log-error', blob);
    } else {
        // Fallback to fetch for older browsers
        fetch('/api/log-error', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(errorData),
            keepalive: true
        }).catch(() => {
            // Silently fail - we don't want error reporting to cause more errors
        });
    }
}
